import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorEnum, getAPIErrorMessage } from '@nw/shared/utils';

import { GetReferralCodeResponseType } from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

const useGetReferralCode = (): {
  getReferralCodeApi: UseMutateAsyncFunction<
    GetReferralCodeResponseType,
    unknown,
    {
      productCode: string;
    },
    unknown
  >;
  error: string;
  status: MutationStatus;
  isInvalidLicenceCodeCarryForwardConfigNotFoundError: boolean;
} => {
  const { paymentServices } = usePaymentServices();

  const getReferralCode = ({ productCode }: { productCode: string }) => {
    return paymentServices.getReferralCode({
      productCode
    });
  };

  const { mutateAsync, error, status } = useMutation(getReferralCode, {
    mutationKey: ['getReferralCodeApi']
  });

  const getReferralCodeApi = mutateAsync;

  const isInvalidLicenceCodeCarryForwardConfigNotFoundError = error && getAPIErrorEnum(error) === 'LICENCE_CODE_CARRY_FORWARD_CONFIG_IS_NOT_FOUND_FOR_PRODUCT_CODE';

  return {
    getReferralCodeApi,
    error: error ? getAPIErrorMessage(error) : '',
    status,
    isInvalidLicenceCodeCarryForwardConfigNotFoundError
  };
};

export { useGetReferralCode };
